function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 6L11.5 1L21 6V8H2V6ZM4 10V17H7V10H4ZM10 10V17H13V10H10ZM21 19V22H2V19H21ZM16 10V17H19V10H16Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskType: "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 1,
  width: 19,
  height: 21
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 6L11.5 1L21 6V8H2V6ZM4 10V17H7V10H4ZM10 10V17H13V10H10ZM21 19V22H2V19H21ZM16 10V17H19V10H16Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#979797"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/portico.15d4fa65.svg";
export { SvgComponent as ReactComponent };